// swiper
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';


// image swipers
const imageSwiper = document.querySelector('.swiper-images');

// create swiper
let swiper = new Swiper(imageSwiper, {
    modules: [Navigation],
    direction: 'horizontal',
    spaceBetween: 0,
    slidesPerView: '4',    
    spaceBetween: 24,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        0: {
            slidesPerView: 1,
        },
        640: {
            slidesPerView: 2,
        },
        768: {
            slidesPerView: 3,
        },
        1024: {
            slidesPerView: 4,
        },
    }
});